"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _radio_props = require("./radio_props");

var _spauiPopover = require("@tencent/spaui-popover");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var prefix = 'spaui-radio';
/**
 * 单选框类
 * @class
 */

var Radio =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Radio, _PureComponent);

  function Radio(props) {
    var _this;

    _classCallCheck(this, Radio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Radio).call(this, props));
    _this.state = {
      checked: props.checked || false
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Radio, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // 一直响应外部的
      this.setState({
        checked: nextProps.checked || false
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          _this$props$isImmedia = _this$props.isImmediatelyRespondChecked,
          isImmediatelyRespondChecked = _this$props$isImmedia === void 0 ? false : _this$props$isImmedia;
      var checked = event.target.checked || false;

      var triggerChange = function triggerChange() {
        if ((0, _spauiUtils.isFunction)(onChange)) {
          onChange(event, checked ? value : '');
        }
      }; // 如果开启了立马响应状态，会先存放在state，然后通过onChange回调传回来最后的结果


      if (isImmediatelyRespondChecked) {
        this.setState({
          checked: checked
        }, function () {
          triggerChange();
        });
      } else {
        triggerChange();
      }
    }
  }, {
    key: "getTipDom",
    value: function getTipDom() {
      var _this$props2 = this.props,
          TipComponent = _this$props2.TipComponent,
          otherProps = _objectWithoutProperties(_this$props2, ["TipComponent"]);

      var result = null;

      if (typeof TipComponent !== 'undefined' && TipComponent) {
        if ((0, _spauiUtils.isReactNode)(TipComponent)) {
          result = TipComponent;
        } else {
          result = _react["default"].createElement(TipComponent, otherProps);
        }
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props3 = this.props,
          size = _this$props3.size,
          textChecked = _this$props3.textChecked,
          disabled = _this$props3.disabled,
          value = _this$props3.value,
          name = _this$props3.name,
          TextComponent = _this$props3.TextComponent,
          _this$props3$tagName = _this$props3.tagName,
          tagName = _this$props3$tagName === void 0 ? 'label' : _this$props3$tagName,
          canCancelCheck = _this$props3.canCancelCheck,
          inputTip = _this$props3.inputTip,
          _this$props3$OverlayT = _this$props3.OverlayTriggerProps,
          OverlayTriggerProps = _this$props3$OverlayT === void 0 ? {} : _this$props3$OverlayT,
          checkedClassName = _this$props3.checkedClassName,
          hideIcon = _this$props3.hideIcon;
      var checked = this.state.checked;
      var TagName = tagName;
      var tagNameProps = {};
      var result = null;
      var labelClassName = '';
      var indicatorElement = null;
      indicatorElement = !hideIcon ? _react["default"].createElement("span", {
        className: "".concat(prefix, "-indicator")
      }) : null;
      labelClassName = (0, _classnames["default"])("".concat(prefix, " ").concat(prefix, "-base"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefix, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefix, "-xlg"), size === 'extralarge'), _defineProperty(_classNames, "".concat(prefix, "-checked"), checked), _defineProperty(_classNames, "".concat(prefix, "-disabled"), disabled), _defineProperty(_classNames, checkedClassName, checked && checkedClassName), _classNames));

      tagNameProps.onClick = function (event) {
        if (disabled) {
          return;
        }

        event.target.checked = canCancelCheck ? !checked : true;
        event.target.value = value;
        event.target.name = name;
        event.currentTarget.checked = canCancelCheck ? !checked : true;
        event.currentTarget.value = value;
        event.currentTarget.name = name;

        _this2.handleChange(event);
      };

      if (inputTip) {
        indicatorElement = _react["default"].createElement(_spauiPopover.OverlayTrigger, _extends({
          overlay: _react["default"].createElement(_spauiPopover.PopOver, null, inputTip)
        }, _radio_props.defaultOverlayTriggerProps, OverlayTriggerProps), indicatorElement);
      }

      if (textChecked) {
        // 文案可点击选
        result = _react["default"].createElement(TagName, _extends({}, (0, _spauiUtils.globalProps)(this.props, {
          className: labelClassName,
          supportAllEvents: true
        }, Radio), tagNameProps), indicatorElement, _react["default"].createElement(TextComponent, this.props), this.getTipDom());
      } else {
        // 文案不可点击是把文案放在label外面
        result = _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
          supportAllEvents: true,
          className: 'spaui-radio-text-unchecked'
        }, Radio), _react["default"].createElement(TagName, _extends({
          className: labelClassName
        }, tagNameProps), indicatorElement), _react["default"].createElement(TextComponent, this.props), this.getTipDom());
      }

      return result;
    }
  }]);

  return Radio;
}(_react.PureComponent); // 组件标记


_defineProperty(Radio, "propTypes", _radio_props.propTypes);

_defineProperty(Radio, "defaultProps", _radio_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Radio, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Radio;
exports["default"] = _default;